import React from "react";
import { Form, Input, required, Icon, Tooltip } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { INotificationField } from "./INotificationField";

export const NOTIFICATION_TITLE_MAX_LENGTH = 50;

export const TitleField = ({
  notification,
  isEditMode,
  isHidden,
}: INotificationField) => {
  const { t } = useTranslation();

  if (isHidden) {
    return null;
  }

  return (
    <Form.Item
      name="Title"
      label={
        <span>
          {t("NOTIFICATION_TITLE_FIELD")}&nbsp;
          <Tooltip title="Camp obligatori delimitat per un màxim de 50 caràcters. Cal anar amb compte, ja que en seleccionar el emplenat automàtic, si el contingut supera els 50 caràcters es trunca automàticament fins a aquest màxim.">
            <Icon type="question-circle" />
          </Tooltip>
        </span>
      }
      key="Title"
      initialValue={isEditMode ? notification?.Title || "" : ""}
      rules={[required()]}
    >
      <Input
        placeholder={t("NOTIFICATION_TITLE_INPUT_FIELD")}
        maxLength={NOTIFICATION_TITLE_MAX_LENGTH}
        showCount={true}
      />
    </Form.Item>
  );
};
